<template>
    <div>
        <span class="ml-3 h4 cursor-pointer"
            @click="toggleWishlist()"
            data-placement="left"
            data-toggle="tooltip"
            data-trigger="hover"
            :data-original-title="
                inWishlist
                    ? dataTexts.remove_from_wishlist
                    : dataTexts.add_to_wishlist
            "><i
                :class="{
                    'icon-line-bookmark':
                        !inWishlist,
                    'icon-bookmark21': inWishlist,
                }"
            ></i
        ></span>
    </div>
</template>

<script>
    export default {
        props: ['dataTexts', 'dataInWishlist', 'dataProductId'],
        data() {
            return {
                inWishlist: this.dataInWishlist
            }
        },
        methods: {
            toggleWishlist() {
                axios
                    .get("/ajax/wishlist", {
                        params: {
                            product_id: this.dataProductId,
                        },
                    })
                    .then((response) => {
                        if (response.data.find((id) => this.dataProductId == id)) {
                            this.inWishlist = true
                        } else {
                            this.inWishlist = false
                        }
                        this.$root.$emit("updateWishlist", response.data.length);
                    });
            },
        },
    }
</script>
